import React from 'react';
import { motion } from 'framer-motion';
import { Mail } from 'lucide-react';
export function ThankYouPage() {
  return <div className="min-h-screen bg-background font-sans selection:bg-skyblue/30" data-id="element-1">
      {/* SECTION 1: URGENCY BAR */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-success py-3 px-4 shadow-md" data-id="element-2">
        <p className="text-center text-white font-bold text-sm tracking-wide" data-id="element-3">
          ✅ ¡COMPRA CONFIRMADA! Tu pedido fue procesado con éxito.
        </p>
      </div>

      {/* Main Content Container */}
      <div className="pt-24 pb-16 px-5 sm:px-6 flex justify-center w-full" data-id="element-4">
        <div className="w-full max-w-[580px] flex flex-col gap-12" data-id="element-5">
          {/* SECTION 2: HERO */}
          <motion.section initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="text-center flex flex-col items-center pt-4" data-id="element-6">
            <div className="text-6xl sm:text-7xl mb-6" data-id="element-7">🎉</div>
            <h1 className="text-4xl sm:text-5xl font-extrabold text-white mb-4 leading-[1.15] tracking-tight" data-id="element-8">
              ¡Bienvenido al equipo, crack! 🇦🇷
            </h1>
            <h2 className="text-xl sm:text-2xl font-medium text-skyblue" data-id="element-9">
              Tu compra fue procesada con éxito.
            </h2>
          </motion.section>

          {/* SECTION 3: INSTRUCCIÓN PRINCIPAL */}
          <motion.section initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2,
          ease: 'easeOut'
        }} className="bg-card border border-gold/40 rounded-2xl p-6 sm:p-8 shadow-[0_0_25px_rgba(245,197,24,0.1)] flex flex-col items-center text-center relative overflow-hidden" data-id="element-10">
            {/* Subtle top glow line */}
            <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-gold to-transparent opacity-60" data-id="element-11"></div>

            <div className="bg-gold/10 p-4 rounded-full mb-5" data-id="element-12">
              <Mail className="w-10 h-10 text-gold" strokeWidth={1.5} data-id="element-13" />
            </div>

            <h3 className="text-2xl sm:text-3xl font-bold text-gold mb-5" data-id="element-14">
              Revisá tu correo ahora
            </h3>

            <div className="text-gray-200 space-y-4 text-base sm:text-lg leading-relaxed mb-8" data-id="element-15">
              <p data-id="element-16">
                En los próximos minutos vas a recibir un email con todo lo que
                necesitás para acceder a tu producto.
              </p>
              <p data-id="element-17">
                Si no lo ves en tu bandeja principal, revisá la carpeta de SPAM
                o Promociones. A veces se cuela por ahí.
              </p>
            </div>

            <div className="bg-[#0F172A] border border-blue-900/50 rounded-xl p-4 sm:p-5 w-full text-left flex gap-3 sm:gap-4 items-start shadow-inner" data-id="element-18">
              <span className="text-xl shrink-0 mt-0.5" data-id="element-19">💡</span>
              <p className="text-sm sm:text-base text-blue-50 font-medium leading-snug" data-id="element-20">
                <span className="font-bold text-white" data-id="element-21">TIP:</span> Guardá el
                email en tu bandeja principal para no perder ninguna
                actualización futura.
              </p>
            </div>
          </motion.section>

          {/* SECTION 4: CIERRE CÁLIDO */}
          <motion.section initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: 0.5
        }} className="text-center flex flex-col gap-6 mt-2" data-id="element-22">
            <p className="text-lg sm:text-xl text-white/90 font-medium leading-relaxed px-2" data-id="element-23">
              Gracias por confiar en nosotros.
              <br className="hidden sm:block" data-id="element-24" /> Tomaste una gran decisión para
              tu negocio. 🤝
            </p>

            <div className="w-12 h-[1px] bg-white/10 mx-auto" data-id="element-25"></div>

            <p className="text-sm text-gray-400 italic" data-id="element-26">
              ¿Dudas? Escribinos a <br className="sm:hidden" data-id="element-27" />
              <a href="mailto:info@oportunidadesonline.online" className="text-gray-300 hover:text-white transition-colors underline decoration-gray-600 underline-offset-4 ml-1 sm:ml-0" data-id="element-28">
                info@oportunidadesonline.online
              </a>
            </p>
          </motion.section>
        </div>
      </div>
    </div>;
}